import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Parses and formats a phone number string.
 * Tries to parse as US number first, then falls back to manual digit extraction.
 * @param phone The input phone string
 * @returns The formatted phone number in E.164 format (e.g. +15551234567) or null if invalid
 * @throws Error if the phone number is invalid
 */
export const parseAndFormatPhone = (phone: string): string => {
  if (!phone) return "";

  try {
    // 1. Try standard parsing first
    const phoneNumber = parsePhoneNumberFromString(phone, "US");

    if (phoneNumber?.isValid()) {
      return phoneNumber.number as string;
    }
  } catch {
    // Ignore parsing errors and fall back to manual
  }

  // 2. Manual fallback
  const digits = phone.replaceAll(/\D/g, "");

  if (digits.length === 10) {
    // Assume US 10-digit number
    return `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith("1")) {
    // Assume US 11-digit number with country code
    return `+${digits}`;
  }

  throw new Error("Invalid phone number format.");
};
